import { useQuery } from '@tanstack/react-query';

type InviteData = {
  first_name: string;
  inviter_name: string;
  email: string;
  ory_link: string;
};

export const useInviteData = (tenantId: string | undefined, token: string | undefined) => {
  const { data, isLoading, isError, error } = useQuery<InviteData>({
    queryKey: ['public', `invite-data/${tenantId}/${token}`],
    enabled: !!tenantId && !!token,
    retry: false,
  });

  return {
    data,
    isLoading,
    isError,
    error,
  };
};
